import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GpsService {

  constructor() { }

  public getGpsCoordinates(options?: PositionOptions): Promise<GeolocationPosition> {
    return new Promise<GeolocationPosition>((resolve, reject) => {
      console.log('Obtener ubicación GPS')
      options = options || {}
      options.enableHighAccuracy = options.enableHighAccuracy != null ? options.enableHighAccuracy : true
      options.timeout = options.timeout != null ? options.timeout : 5000
      options.maximumAge = options.maximumAge != null ? options.maximumAge : 5000
  
      let _this = this // Para recuperar el contexto.
      let successCallback = (position: GeolocationPosition) => {
        console.log('success')
        console.log(position)
        resolve(position)
      }

      let errorCallback = (positionError: GeolocationPositionError) => {
        console.log('error')
        reject(positionError)
      }
  
      navigator.geolocation.getCurrentPosition((position) => {
        successCallback.call(_this, position)
      }, (positionError) => {
        errorCallback.call(_this, positionError)
      }, options)
    })
  }

}
